module.exports = __webpack_public_path__ + "static/media/customer-rganik.d53299b2.png";